import { FilterI } from '~src/shared/lists/listFilters/ListFilters';
import { SortingOption } from '~src/shared/sortSelector/SortSelector';

import { SurveyTypeIcon, surveyTypes } from './surveyTypes';

export enum FilterTypes {
  All = 'all',
  General = 'general',
  PeopleThreeSixty = 'people_three_sixty',
  PeopleBottomUp = 'people_bottom_up',
  PeopleTopDown = 'people_top_down',
  Groups = 'groups',
  People = 'people',
}

const filterTypesArr = Object.values(FilterTypes) as FilterTypes[];

export interface SurveysFilter extends FilterI {
  id: FilterTypes;
  iconName?: SurveyTypeIcon;
}

export const filterOptions: ReadonlyArray<Readonly<SurveysFilter>> = [
  {
    id: FilterTypes.All,
    labelKey: 'x.scales.list.filters.all',
  },
  ...surveyTypes.map((item, i) => ({
    id: filterTypesArr[++i],
    labelKey: item.name,
    iconName: item.iconName,
    tooltipKey: item.description,
    disabled: true,
  })),
];

export enum StatusFilterTypes {
  All = 'all',
  Active = 'active',
  Draft = 'draft',
}

export const statusFilterOptions: ReadonlyArray<Readonly<SortingOption>> = [
  {
    name: StatusFilterTypes.All,
    translationKey: 'x.surveys.list.status_filter.all',
  },
  {
    name: StatusFilterTypes.Active,
    translationKey: 'x.surveys.schedules.listitem.activebox.active',
  },
  {
    name: StatusFilterTypes.Draft,
    translationKey: 'x.surveys.schedules.listitem.activebox.draft',
  },
];
